import { urlApiAuth, urlApiCanvas } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBodyLogin, ILoginUrl, IResponseLogin } from '~/utils/interface/auth';
import { IBaseResponse } from '~/utils/interface/base';

const authApi = {
  login(payload: { body: IBodyLogin }) {
    const { body } = payload;
    const url = `${urlApiAuth.login}`;
    return axiosClient.post<IBaseResponse<IResponseLogin>>(url, body);
  },

  getLoginUrl() {
    const url = `${urlApiCanvas.signIn}`;
    return axiosClient.get<IBaseResponse<ILoginUrl>>(url);
  },

  createCanvasToken(payload: { code: string; state?: string }) {
    const url = `${urlApiCanvas.createCanvasToken}`;
    return axiosClient.post<IBaseResponse<IResponseLogin>>(url, payload);
  },
};

export default authApi;
